document.addEventListener("DOMContentLoaded", function () {

  const hero = document.querySelector(".ofertas-flash-hero");
  if (!hero) return;

  const hours = parseInt(hero.dataset.hours);
  const timerDisplay = document.getElementById("countdown-timer");

  const storageKey = "ofertasFlashEndTime";

  let endTime = localStorage.getItem(storageKey);

  if (!endTime) {
    endTime = new Date().getTime() + hours * 60 * 60 * 1000;
    localStorage.setItem(storageKey, endTime);
  }

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endTime - now;

    if (distance <= 0) {
      localStorage.removeItem(storageKey);
      timerDisplay.innerHTML = "00:00:00";
      return;
    }

    const h = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const m = Math.floor((distance / (1000 * 60)) % 60);
    const s = Math.floor((distance / 1000) % 60);

    timerDisplay.innerHTML =
      String(h).padStart(2, "0") + ":" +
      String(m).padStart(2, "0") + ":" +
      String(s).padStart(2, "0");
  }

  setInterval(updateCountdown, 1000);
});
